import './DepositsEmptyState.scss';
// @ vendors
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { i18n } from 'core/i18n';
import classNames from 'classnames';
// @ commons
import { EmptyState } from 'commonsComponents/emptyState'
// @utils
import { recordLink } from "utilities/tagging";
// @constants
import { 
    DEPOSIT_EMPTY_STATE_CLOSED_DEPOSITS, 
    DEPOSIT_EMPTY_STATE_NO_HIRED, 
    DEPOSIT_EMPTY_STATE_LANDING, 
    DEPOSIT_EMPTY_STATE_NO_HIRED_VIEW 
} from 'constants/tagging';

const DepositsEmptyState = ({ hasClosedDeposits, hasOffers, handleLinkClick }) => {
    const { FormattedText } = i18n;
    useEffect(() => {
        const eventTag = hasClosedDeposits ? DEPOSIT_EMPTY_STATE_CLOSED_DEPOSITS : DEPOSIT_EMPTY_STATE_NO_HIRED;
        recordLink(DEPOSIT_EMPTY_STATE_LANDING, DEPOSIT_EMPTY_STATE_NO_HIRED_VIEW, eventTag);
    }, []);

    const emptyStateClasses = classNames('deposits-empty-state', {
        'deposits-empty-state--risk-level': hasOffers
    });

    const formattedValue = hasClosedDeposits
        ? "deposits-deposits_emptyStateClosedDeposits"
        : "deposits-deposits_emptyStateNoClosedDeposits";

    const primaryText = (
        <div>
            <FormattedText value={formattedValue} /> {hasClosedDeposits && (
                <a onClick={() => handleLinkClick(true)}>
                    <FormattedText value="deposits-deposits_emptyStateDepositsCTA" />
                </a>
            )}
        </div>
    )

    return (
        <section className={emptyStateClasses}>
            <EmptyState
                iconType="noitems-banking"
                primaryText={primaryText}
                withMargin={false}
            />
        </section>
    )
}

DepositsEmptyState.propTypes = {
    hasClosedDeposits: PropTypes.bool.isRequired,
    hasOffers: PropTypes.bool.isRequired,
    handleLinkClick: PropTypes.func.isRequired,
};

export default DepositsEmptyState;